import {
  GET_RU_SUB_LOT_BY_ID, REFRESH_RU_SUB_LOT_IDS, LOAD_RU_SUB_LOTS, UPDATE_RU_SUB_LOT_STORE,
  PUSH_RU_EMPTY_SUBLOT, ERASE_RU_SUB_LOTS, ERASE_RU_SUB_LOT_BY_ID, ERASE_OPTIONALS_BY_SUB_LOT, REFRESH_OPTIONALS_SUB_LOT_IDS
} from '../types';
import UsedRentalsSubLotAPI from '../../../API/UsedRentalsSubLotsAPI';
import { RAPPEL_INITIAL_VALUE } from '../../../Utils/Constants';
import store from '../../store';

const newEmptySubLot = {
  "ColdId": 0,
  "Id": 0,
  "L1ID": 0,
  "NumA1": "",
  "NumClientReferenceProposal": "",
  "NumClientRefSchedule": "",
  "NumClientRefScheduleDate": "",
  "Quantity": "",
  "RappelDiscountId": RAPPEL_INITIAL_VALUE,
  "RappelDiscountDetail": "",
  "DiscountPercentage": "",
  "DiscountInvoice": "",
  "DiscountOutsideInvoice": "",
  "SMEDiscount": "",
  "BusinessDiscount": "",
  "NoVATInvoiceValue": "",
  "NoVATInvoiceValueString": "",
  "InvoiceDiscountValue": "",
  "InvoiceDiscountValueString": "",
  "PBOptionalsValue": "",
  "PBOptionalsValueString": "",
  "OutOfInvoiceDiscountValue": "",
  "OutOfInvoiceDiscountValueString": "",
  "LPGains": "",
  "LicensePlateRegistrationYear": "",
  "AverageKm": "",
  "ReferenceRentalPrice": "",
  "AditionalMargin": "",
  "AditionalMarginString": "",
  "LPGainsObservations": "",
  "SubLotCarOptionals": [],
  "ShouldPersist": true
}

export const getSubLotById = (nSubLotId) => dispatch => {

  return new Promise(function (resolve, reject) {

    const oNegotiationSubLotAPI = new UsedRentalsSubLotAPI();
    oNegotiationSubLotAPI.getSubLotById(nSubLotId).then(response => {
      dispatch({
        type: GET_RU_SUB_LOT_BY_ID,
        payload: { ...response.data, nSubLotId }
      });
      return resolve();

    }).catch((error) => {
      return reject(error);
    });
  });

}

export const updateSubLotStore = (propName, propValue, nSubLotId) => dispatch => {
  return dispatch({
    type: UPDATE_RU_SUB_LOT_STORE,
    payload: { propName, propValue, nSubLotId }
  });
}

export const getMyOwnDataById = (state, nSubLotId) => {
  //should probably invoke the state here instead of passing it so I can reuse this
  return state.usedRentalsSubLots[nSubLotId];
}

export const pushNewEmptySubLot = () => dispatch => {
  let state = store.getState();
  let aSubLots = state.usedRentalsSubLots;
  let aSubLotIds = [];

  for (var key in aSubLots) {
    if (aSubLots.hasOwnProperty(key)) {
      aSubLotIds.push(key);
    }
  }
  let maxSubLotId = 0;
  if (aSubLotIds.length > 0)
    maxSubLotId = Math.max(...aSubLotIds);

  maxSubLotId = maxSubLotId + 1;
  let newColdId = maxSubLotId.toString();

  const emptySubLotWithId = {
    [newColdId]: { ...newEmptySubLot }
  }

  emptySubLotWithId[newColdId].ColdId = newColdId;

  dispatch({
    type: PUSH_RU_EMPTY_SUBLOT,
    payload: emptySubLotWithId
  });
  return newColdId;
}

export const eraseSubLots = () => dispatch => {

  return dispatch({
    type: ERASE_RU_SUB_LOTS
  });

}

export const eraseSubLotById = (nSubLotId) => dispatch => {
  dispatch({
    type: ERASE_OPTIONALS_BY_SUB_LOT,
    payload: nSubLotId
  });
  return dispatch({
    type: ERASE_RU_SUB_LOT_BY_ID,
    payload: nSubLotId
  });
}

export const refreshRUSubLotIDs = (oColdToHotSubLotIdMap, lotId) => dispatch => {
  if (oColdToHotSubLotIdMap != null) {
    dispatch({
      type: REFRESH_OPTIONALS_SUB_LOT_IDS,
      payload: { ColdToHotSubLotIdMap: oColdToHotSubLotIdMap }
    });
  }
  return dispatch({
    type: REFRESH_RU_SUB_LOT_IDS,
    payload: { ColdToHotSubLotIdMap: oColdToHotSubLotIdMap, lotId }
  });
}

export const loadSubLots = (aSubLotIds) => dispatch => {
  if (aSubLotIds.length === 0) {
    const emptySubLotWithId = {
      0: { ...newEmptySubLot }
    }

    dispatch({
      type: PUSH_RU_EMPTY_SUBLOT,
      payload: emptySubLotWithId
    });
  } else {
    let payload = {};
    aSubLotIds.forEach(element => {
      let nome = element.toString();
      var newSubLot = { ...newEmptySubLot };
      newSubLot.Id = element;
      newSubLot.ShouldPersist = false;
      payload[nome] = { ...newSubLot };
    });

    return dispatch({
      type: LOAD_RU_SUB_LOTS,
      payload: payload
    });
  }

}


// WEBPACK FOOTER //
// ./src/store/actions/RU/creationSubLotActions.js